import React from 'react';
import {
  addPathToList, Asset_requirements_paragraph,
  Change_receiving_account,
  File_type,
  getSubCategoryId,
  payment_amount,
  your_customer_can_click,
} from '../utils/DictionaryManagementUtils';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';
import AssetRequirements from '../components/PanelsComponents/General/AssetRequirements';

//= ========================================================================

const Panel_G08_SplitPaymentPayingAccount = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onGotoEdit,
  onStepPressed,
  language,
}) => {
  const editTextList = [
    'select_paying_account',
  ];
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const subCategoryIdDefault = getSubCategoryId({ sub_category: myScreen.sub_category, duplication_number: 0 });
  const service = globJSON.configurations.services[subCategoryId];

  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      onStepPressed={onStepPressed}
      onGotoEdit={onGotoEdit}
      panelHeadline={payment_amount}
      panelSubHeadline={Change_receiving_account}
      editTextList={addPathToList(editTextList, `configurations/services/${subCategoryId}/amount/`)}
      editTextListDefault={addPathToList(editTextList, `configurations/services/${subCategoryIdDefault}/amount/`)}
      tooltipsTitles={service.screens_ordering}
      paragraph={your_customer_can_click}
      language={language}
    >
      <AssetRequirements paragraph={Asset_requirements_paragraph} details={File_type} />
    </FullPagePanel>
  );
};

export default Panel_G08_SplitPaymentPayingAccount;
